import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Subject } from "rxjs";
import { AuthService } from "../../../../core/auth/_services";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AuthNoticeService } from "../../../../core/auth";
import { environment } from "../../../../../environments/environment";

const API_SMS_URL = environment.API_URL + "api/IntencionReventas/validation";

@Component({
  selector: "kt-sms",
  templateUrl: "./sms.component.html",
  encapsulation: ViewEncapsulation.None,
  styleUrls: ["./sms.component.css"]
})
export class SMSComponent implements OnInit, OnDestroy {
  form: FormGroup;
  loading = false;
  errors: any = [];

  private unsubscribe: Subject<any>;
  private id;

  constructor(
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private http: HttpClient,
    private cdr: ChangeDetectorRef,
    private authNoticeService: AuthNoticeService,
    private router: Router
  ) {
    this.unsubscribe = new Subject();
    this.id = this.activatedRoute.snapshot.params.id;
  }

  ngOnInit() {
    this.initForm();
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.loading = false;
  }

  initForm() {
    this.form = this.fb.group({
      code: [null, Validators.compose([Validators.required, Validators.max(999999)])]
    });
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.form.controls[controlName];
    if (!control) {
      return false;
    }
    return control.hasError(validationType) && (control.dirty || control.touched);
  }

  submit() {
    const controls = this.form.controls;

    if (this.form.invalid) {
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      return;
    }

    let request = {
      IntencionReventaId: this.id,
      ValidationCode: controls["code"].value
    };

    this.loading = true;
    const httpHeaders = new HttpHeaders();
    httpHeaders.set("Content-Type", "application/json");
    this.http
      .post(API_SMS_URL, request, { headers: httpHeaders })
      .subscribe(
        (value) => {
          this.authNoticeService.setNotice("Se ha validado el celular con éxito. Ya podés iniciar sesión.", "success");
          return this.router.navigateByUrl("/auth/login");
        },
        (error) => {
          this.authNoticeService.setNotice("No se ha podido validar el celular con el código ingresado", "danger");
        }
      )
      .add(() => {
        this.loading = false;
        this.cdr.detectChanges();
      });
  }
}
